import axios from "axios";

export const instance = axios.create({
  // baseURL : REST_ENDPOINT,
  withCredentials: true,
});

export default instance;
